import { create } from '@wix/fedops-logger';

const fedopsLogger = create('account-teams-client');
fedopsLogger.appLoadStarted();

export default fedopsLogger;

export function addInteractionMonitoring<Args extends Array<any>, Result>(f: (...args: Args) => Promise<Result>, name: string): (...args: Args) => Promise<Result> {
  return (...args: Args) => {
    fedopsLogger.interactionStarted(name);
    return f(...args).then(result => {
      fedopsLogger.interactionEnded(name);
      return result;
    });
  };
}
